import styled from 'styled-components';

export const ModalBodyText = styled.p<{
  $margin?: string;
}>`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  margin : ${({ $margin }) => $margin};
  line-height: 1.5;
`;



export const ModalHeaderText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  display: block;
`;

export const ModalSubheaderText = styled.h6`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.darkGray};
  margin: ${({ theme }) => `${theme.spacing.md} 0`};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
